var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useIntl } from 'react-intl';
import { useMutation } from '@apollo/client';
import { useSnackbar } from 'notistack';
import { useDrawer } from 'context/DrawerContext';
import sharedMessages from 'translations/shared';
import { track, SegmentTrackableEnum } from 'factory/SegmentFactory';
import getTaxRatesQuery from './query.graphql';
import createTaxRateMutation from './addTaxRate.graphql';
import View from './View';
var Container = function (props) {
    var onError = props.onError, onSuccess = props.onSuccess;
    var closeDrawer = useDrawer().closeDrawer;
    var formatMessage = useIntl().formatMessage;
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var _a = __read(useMutation(createTaxRateMutation, {
        onCompleted: function (data) {
            if (onSuccess)
                onSuccess(data.addTaxRate);
            track(SegmentTrackableEnum.TAX_RATE_CREATED, __assign({}, data));
            enqueueSnackbar(formatMessage(sharedMessages.addedTaxRate), {
                variant: 'success',
            });
            closeDrawer();
        },
        onError: function (error) {
            enqueueSnackbar(error.message, { variant: 'error' });
            if (onError)
                onError(error);
        },
        refetchQueries: [{ query: getTaxRatesQuery }],
    }), 2), createTaxRate = _a[0], createResult = _a[1];
    var onCreate = function (input) {
        createTaxRate({
            variables: {
                input: input,
            },
        });
    };
    return (_jsx(View, { onCreate: onCreate, error: createResult.error, isProcessing: createResult.loading }, void 0));
};
export default Container;
